export default [
    {
        path: "/exhibitionList",
        component: resolve => require(["@/views/exhibition/exhibitionList"], resolve),
        meta: {
            title: "藏品列表"
        }
    },
    {
        path: "/exhibits",
        component: resolve => require(["@/views/exhibition/exhibits"], resolve),
    },
    {
        path: "/exhibitsDetail",
        component: resolve => require(["@/views/exhibition/exhibitsDetail"], resolve),
        meta: {
            title: "展览详情"
        }
    },
    {
        path: "/detailExhibition",
        component: resolve => require(["@/views/exhibition/detailExhibition"], resolve),
        meta: {
            title: "展品详情"
        }
    },
    {
        path: "/search",
        component: resolve => require(["@/views/exhibition/search"], resolve),
        meta: {
            title: "搜索"
        }
    },


];


// WEBPACK FOOTER //
// ./src/router/modules/exhibition.js